export default __webpack_public_path__ + "static/media/002_0.6f26a4dc.jpg";